import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF, faXTwitter, faLinkedinIn } from '@fortawesome/free-brands-svg-icons'
// import { faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
const Footer = () => {
    return (
        <footer id="footer" className="footer-section py-5">
            <div className="container" data-aos="fade-up">
                <div className="row g-5">
                    {/* Company Info */}
                    <div className="col-lg-4">
                        <h3 className="fw-bold mb-3">
                            Anmatics<sup>®</sup> Technologies
                        </h3>
                        <p className="text-white mb-4">
                            Delivering innovative software solutions and SaaS products that empower businesses
                            worldwide to innovate, scale, and grow with confidence.
                        </p>

                        {/* <div className="office-locations">
                            <div className="mb-3">
                                <h6 className="fw-semibold text-white mb-1">
                                    <FontAwesomeIcon icon={faMapMarkerAlt} className="me-2 text-black" />
                                    Morbi Office
                                </h6>
                                <p className="text-white small mb-0">
                                    207, Second Floor, City Mall,<br />
                                    Nr. Bhaktinagar Bypass, Sanala Road,<br />
                                    Morbi, Gujarat - 363641, India
                                </p>
                            </div>
                            <div>
                                <h6 className="fw-semibold text-white mb-1">
                                    <FontAwesomeIcon icon={faMapMarkerAlt} className="me-2 text-black" />
                                    Rajkot Office
                                </h6>
                                <p className="text-white small mb-0">
                                    203, Ikon Complex, Opp. Sun City Apartment,<br />
                                    Sadhu Vaswani Road, Rajkot - 360005, India
                                </p>
                            </div>
                        </div> */}
                    </div>

                    {/* Quick Links */}
                    <div className="col-lg-4 col-md-6">
                        <h5 className="fw-bold text-white mb-3">Quick Links</h5>
                        <ul className="footer-links list-unstyled">
                            <li><a href="/#home">Home</a></li>
                            <li><a href="/#about">About</a></li>
                            <li><a href="/#services">Services</a></li>
                            <li><a href="/#product">Product</a></li>
                            <li><a href="/#contact">Contact</a></li>
                        </ul>
                    </div>

                    {/* Social Media */}
                    <div className="col-lg-4 col-md-6">
                        <h5 className="fw-bold text-white mb-3">Follow Us</h5>
                        <div className="social-icons d-flex gap-3">
                            <a href="https://www.facebook.com/share/16xFv6aVpA/?mibextid=wwXIfr" className="social-icon">
                                <FontAwesomeIcon icon={faFacebookF} size="2x" />
                            </a>
                            <a href="https://x.com/anmatics-technologies/" className="social-icon">
                                <FontAwesomeIcon icon={faXTwitter} size="2x" />
                            </a>
                            <a href="https://www.linkedin.com/company/anmatics-technologies/" className="social-icon">
                                <FontAwesomeIcon icon={faLinkedinIn} size="2x" />
                            </a>
                        </div>
                    </div>
                </div>

                {/* Footer Bottom */}
                <div className="footer-bottom text-center mt-5 pt-4 border-top border-light-subtle">
                    <p className="text-white mb-0">
                        &copy; {new Date().getFullYear()} Anmatics<sup>®</sup> Technologies. All Rights Reserved.
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
